import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${({ noBackground }) => (noBackground ? 'transparent' : '#fff')};
    padding: var(--padding-base);
    border-radius: var(--border-radius);
`;
